<template>
  <div>
    <!-- page-wrapper Start-->
    <div class="container-fluid p-0">
      <div class="row m-0">
        <div class="col-12 p-0">
          <div class="login-card">
            <div>
              <div class="h1 text-danger text-center align-self-center">
                {{ EnvTitle }}
              </div>
              <div>
                <a class="logo">
                  <img :src="LogoPath"
                    class="img-fluid" style="width:250px;padding: 10px 0px;" alt="CPS+ eMarketplace" />
                </a>
              </div>
              <div class="login-main m-t-0" style="margin-bottom: 180px">
                <b-card no-body>
                  <b-card-text class="p-30">
                    <div class="d-flex flex-row-reverse">
                      <language variant="white"></language>
                    </div>
                    <div class="mt-2 mb-3">
                      <h4 class="text-center font-weight">{{ $t("lbl_EMPBE_ResetAccPassword") }}</h4>
                    </div>
                    <div class="alert alert-light" v-html="$t('lbl_EMPBE_Login_Desc')">
                    </div>
                    <!-- <form class="theme-form" @submit.prevent="handleSubmit">                     
                    </form> -->
                    <ValidationObserver ref="updatePasswordForm">
                      <p>{{ $t('lbl_emp2_ValidPasswordVerification') }}</p>
                      <div class="form-group mt-4">
                        <textbox :title='$t("lbl_EMPBE_Password")' type="password" v-model="passwordjwt"
                          name="passwordjwt" ref="passwordjwt" :mandatory='$t("lbl_EMPBE_Password")'
                          :rules="{ required: true, min: 8, regex: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@@$!%*#?&^~+=_\-]{8,}$/ }"
                          vid="passwordjwt">
                        </textbox>
                        <!-- :class="{ 'is-invalid': submitted && !passwordjwt }" -->
                      </div>
                      <div class="form-group mt-4">
                        <textbox :title='this.$t("lbl_emp2_Password_SameValue")' type="password" v-model="repasswordjwt"
                          name="repasswordjwt" ref="repasswordjwt" :mandatory='$t("lbl_emp2_Password_SameValue")'
                          rules="required|confirmed:passwordjwt" vid="repasswordjwt">
                        </textbox>
                        <!-- :class="{ 'is-invalid': submitted && !repasswordjwt }"  |confirmed:passwordjwt :rules="{ required: true, confirmed: passwordjwt }" -->
                      </div>

                      <!-- <div class="form-group is-invalid">
                        <div v-if="submitted && State_alert == 'alert-danger'" class="invalid-feedback d-block">
                          重置密码失败
                        </div>

                      </div> -->
                      <div class="form-group mt-5 mb-0">
                        <button class="btn btn-primary btn-block" v-bind:t_label="'EMPBE_LoginPage_btnLogin'"
                          @click="handleSubmit">
                          {{ $t("lbl_EMPBE_Submit") }}
                        </button>
                      </div>
                      <aliyunCaptcha @slideCallback="finishSlide" :reload="reloadCaptcha" ref="captcha">
                      </aliyunCaptcha>
                    </ValidationObserver>
                  </b-card-text>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- latest jquery-->
  </div>
</template>

<script>
// import firebase from 'firebase';
import { adminService } from '../../src/_services';
import Userauth from '../auth/js/index';
import language from '../components/header/language.vue';
import { mapState } from 'vuex';
import aliyunCaptcha from '../components/aliyunCaptcha.vue';

export default {
  components: {
    language,
    aliyunCaptcha
  },
  name: 'ResetAccountPassword',
  mounted() {
  },
  data() {
    return {
      type: 'password',
      //password: '',
      passwordjwt: '',
      repasswordjwt: '',
      submitted: false,
      reloadCaptcha: false,
      token: null,
      VerifyGuid: '',
      VerifyCode: '',
    };
  },
  computed: {
    State_alert() {
      return this.$store.state.alert.type;
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    LogoPath() {
      const locale =
        this.langid == "936" ? "sc" : this.langid == "950" ? "tc" : "en";
      const logoEndPoint = `/EMP_logos_${locale}.png?x-oss-process=image/format,webp`;

      return "https://cdn.adsalecdn.com/EMP/2-0/images" + logoEndPoint;
    },
    isUatEnv() {
      var envName = process.env.VUE_APP_EMP_ENV_NAME;

      if (envName.toLowerCase() == 'uat') {
        return true;
      }

      return false;
    },
    EnvTitle(){
      var envName = process.env.VUE_APP_EMP_ENV_NAME;

      if (envName.toLowerCase() == 'uat') {
        return "UAT Environment";
      }
      if (envName.toLowerCase() == 'ai') {
        return "CPS+AI Environment";
      }
      return "";
    },   
  },
  created() {
    // remove alert
    //this.$store.dispatch('alert/clear');
    if (this.isMobile()) {
      alert(this.$t("lbl_EMPBE_MobileAlertPopupMessage"));
    }
    const urlParams = new URLSearchParams(window.location.search);
    this.token = urlParams.get("token");
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$refs.updatePasswordForm.validate().then(result => {
        if (result) {
          this.$refs.captcha.popup();
        }
      });
    },
    finishSlide(data) {
      this.$swal().close();
      this.submitResetAccountPassword();
    },
    submitResetAccountPassword() {
      const { passwordjwt, repasswordjwt } = this;
      const { dispatch } = this.$store;
      this.$refs.updatePasswordForm.validate().then(result => {
        if (result) {
          var param = {
            token: this.token, newPassword: repasswordjwt,
          };
          adminService.ResetAccountPassword(param).then(res => {
            if (!res.isSuccessful) {
              this.showAlert(res.systemErrorMsg.join(';'));
            }
            else {
              //this.showAlert(this.$t('lbl_emp2_ForgetPasswordSuccessTitle'));
              this.$swal({
                text: this.$t('lbl_emp2_ForgetPasswordSuccessTitle'),
                type: 'confirm',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: this.$t('lbl_EMPBE_GoLoginPage'),
                cancelButtonText: this.$t('lbl_EMPBE_Cancel'),
              }).then((result) => {
                if (result.isConfirmed) {
                  this.$router.push('/auth/login');
                }
                else {
                  window.location.reload();
                }
              });
            }
          });
        }
      });
    },
    showAlert(message) {
      this.$swal({
        html: message,
        htmlMode: true,
        //icon: variant, // 可以是 success、error、warning、info、question 等图标
        showConfirmButton: true, // 禁用确认按钮
        confirmButtonText: this.$t('lbl_EMPBE_Confirm'),
        //allowOutsideClick: false, // 防止点击外部关闭
        //allowEscapeKey: false, // 防止按下 ESC 键关闭
      });
    },
    // show/hide password
    showPassword: function () {
      if (this.type === 'password') {
        this.type = 'text';
      } else {
        this.type = 'password';
      }
    },
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  },
};
</script>
<style>
.login-card .login-main {
  width: 452px !important;
}
</style>